import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Worden mijn gegevens of contract opgeslagen?",
    a: "Je analyse en de bijbehorende contracttekst worden tijdelijk opgeslagen om je rapport en gegenereerde brieven te kunnen tonen. Je kunt op verzoek de gegevens laten verwijderen. We delen niets met derden en gebruiken data nooit voor advertenties.",
  },
  {
    q: "Hoe accuraat is de besparingsschatting?",
    a: "We baseren de schatting op je termijnbedrag, het contracttype en marktinformatie. Voor de meest accurate uitkomst raden we aan ook je jaarafrekening te uploaden. De besparing is een indicatie — geen garantie.",
  },
  {
    q: "Hoe wordt mijn contract geanalyseerd?",
    a: "Een team van energie-experts en juristen heeft de logica gebouwd die elk contract regel-voor-regel doorloopt. We checken op vaste leveringskosten, terugleververgoeding voor zonnepanelen, automatische verlengingen, opzegboetes en alle bekende kleine-lettertjes-trucs. Daarna combineren we dat met je termijnbedrag en verbruik voor een betrouwbare schatting.",
  },
  {
    q: "Kan ik de brieven gewoon versturen?",
    a: "De brieven zijn juridisch onderbouwd en in correct Nederlands geschreven. Vul de placeholders (naam, klantnummer, adres) in voordat je verstuurt. Bij twijfel kun je een juridische review door een echte expert kopen voor €29.",
  },
  {
    q: "Wat als ik geen problemen vind in mijn contract?",
    a: "Dat is ook waardevol — je hebt zekerheid. Veel mensen ontdekken dat hun automatische verlenging of leveringskosten niet optimaal zijn, ook bij ogenschijnlijk goede contracten.",
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      className="border-t border-slate-200 bg-slate-50"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-12 py-24">
        <div className="text-center mb-10">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700">
            FAQ
          </span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
            Veel gestelde vragen
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white border border-slate-200 rounded-xl px-5 data-[state=open]:border-blue-200"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-heading font-semibold text-slate-900 text-left py-4 hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-4">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
